import { SideBarState } from "@/apps/merchant3/store/ui/mutations";

const getters = {
  sidebarState: (state: SideBarState): SideBarState => state,
};

export default getters;
